import script from "./BookingsReservationsBookPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingsReservationsBookPage.vue?vue&type=script&setup=true&lang=ts"

import "./BookingsReservationsBookPage.vue?vue&type=style&index=0&id=3d786ccc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d786ccc"]])

export default __exports__